import { render } from "./GroupElement.vue?vue&type=template&id=6131ff45"
import script from "./GroupElement.vue?vue&type=script&lang=js"
export * from "./GroupElement.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kl_keepjoy_work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__